import React, { useState, useEffect } from 'react';

const FakeLoading = ({
  maxDuration = 30000, // 30 secondes par défaut
  onComplete = null, // Callback optionnel quand la progression atteint 99%
  className = ""
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let startTime = Date.now();
    let animationFrame;

    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      const timeRatio = elapsed / maxDuration;

      // Fonction de progression non-linéaire qui ralentit vers la fin
      // Utilise une courbe logarithmique pour ralentir progressivement
      let newProgress;
      if (timeRatio < 0.7) {
        // 70% du temps pour atteindre 60% de progression (démarrage rapide)
        newProgress = (timeRatio / 0.7) * 60;
      } else if (timeRatio < 0.9) {
        // 20% du temps pour passer de 60% à 85% (ralentissement)
        const adjustedRatio = (timeRatio - 0.7) / 0.2;
        newProgress = 60 + (adjustedRatio * 25);
      } else {
        // 10% du temps restant pour passer de 85% à 99% (très lent)
        const adjustedRatio = (timeRatio - 0.9) / 0.1;
        newProgress = 85 + (adjustedRatio * 14);
      }

      // Ajouter un peu de randomness pour rendre ça plus réaliste
      const randomVariation = (Math.random() - 0.5) * 1; // ±0.5%
      newProgress = Math.min(99, Math.max(0, newProgress + randomVariation));

      // S'assurer que le progress ne diminue jamais
      setProgress(prevProgress => Math.max(prevProgress, newProgress));

      // Callback quand on atteint 99%
      if (newProgress >= 99 && onComplete && !onComplete.called) {
        onComplete.called = true;
        onComplete();
      }

      // Continuer l'animation si on n'a pas atteint la fin
      if (timeRatio < 1 && newProgress < 99) {
        animationFrame = requestAnimationFrame(updateProgress);
      }
    };

    animationFrame = requestAnimationFrame(updateProgress);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [maxDuration, onComplete]);

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Message de progression */}
      <div className="text-center">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {Math.round(progress)}% terminé
        </p>
      </div>

      {/* Barre de progression */}
      <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-3">
        <div
          className="bg-gradient-to-r from-blue-500 to-blue-600 h-3 rounded-full transition-all duration-500 ease-out relative overflow-hidden"
          style={{ width: `${Math.max(0, progress)}%` }}
        >
          {/* Effet de brillance qui se déplace */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default FakeLoading;